export const DEFAULT_LIMIT = 10;
export const LIMIT_OPTIONS = [10, 15, 20];
export const INPUT_DEBOUNCE_TIME = 300;
